module.exports = __webpack_public_path__ + "static/media/Dobro - map icons_Tvornica stočne hrane icon (1).9943c026.svg";